import { sleep } from "../utils/sleep";
import axios, { AxiosResponse } from 'axios';
// import { cache } from './cache';

axios.defaults.validateStatus = () => true;
axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Cache-Control'] = 'no-store';
// axios.defaults.headers.common['Pragma'] = 'no-cache';
// axios.defaults.headers.common['Expires'] = '0';
axios.defaults.headers.common['Accept-Language'] = 'ar';

type JsonData = { [key: string]: any };


interface RequestRetrial {
  max: number;
  sleepBetween: number; //ms
}


class HttpService {
  constructor(
    protected client = axios,
    protected requestRetrial: RequestRetrial = { max: 1, sleepBetween: 2000 }) {
  }


  async getJSON<T = JsonData>(url: string, headers = {}, validateStatus = true) {
    const result = await this.performRequest({url, method: 'GET', headers, validateStatus}) as T;
    return result;
  }

  async postJSON<T = JsonData, BT = JsonData>(url: string, data: BT, headers = {}, validateStatus = true) {
    const result = await this.performRequest({url, method: 'POST', data: data!, headers, validateStatus}) as T;
    return result;
  }

  async putJSON<T = JsonData, BT = JsonData>(url: string, data: BT, headers = {}, validateStatus = true) {
    const result = await this.performRequest({url, method: 'PUT', data: data!, headers, validateStatus}) as T;
    return result;
  }

  protected async performRequest(configs: {url: string, method: string, headers?: {[key: string] : string}, data?: JsonData, validateStatus: boolean}) {
    const formattedConfigs = {...configs, validateStatus: configs.validateStatus ? () => true : undefined};
    // const cacheKey = configs.url;

    // if (cache.has(cacheKey)) {
    //   const totalSizeMb = (cache.calculatedSize / (1024 * 1024)).toFixed(3);
    //   const remainingTTL = cache.getRemainingTTL(cacheKey);
    //   console.log(`cache HIT (TTL: ${Math.floor(remainingTTL / 1000)}s - total cache size: ${totalSizeMb}MB)`, JSON.stringify(configs));
    //   return cache.get(cacheKey);
    // }
    // console.log('cache MISS', JSON.stringify(configs));
    
    let counter = 0;
    let res: AxiosResponse<any, any> = await this.client(formattedConfigs);
    while (res.status !== 200 && counter <= this.requestRetrial.max) {
      res = await this.client(formattedConfigs);
      if (counter === this.requestRetrial.max) {
        if (res.status >= 500) {
          console.error(`server error, failed ${this.requestRetrial.max} times`, JSON.stringify({response: res.statusText, staus: res.status, data: res.data, headers: res.headers, configs}));
          throw new Error(res.statusText);
        }
        else return undefined;
      }
      counter++;
      await sleep(this.requestRetrial.sleepBetween);
    }

    // const isBreakingNews = configs.url.endsWith('/api/Home/breaking');
    // if (!isBreakingNews) cache.set(cacheKey, res.data);
    return res.data;
  }
}



export const httpService = new HttpService();